module.exports = __webpack_public_path__ + "bb86fb31fde43f853ff0e17289bcc0b2.png";